var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pre-money-wrap"},[_c('p',{staticClass:"title"},[_vm._v("诚意金")]),_vm._v(" "),_c('div',{staticClass:"money-list"},[_c('ul',_vm._l((_vm.moneyList),function(item){return _c('li',{class:{'active':item==_vm.choosedMoney},on:{"click":function($event){_vm.chooseMoney(item)}}},[_vm._v(_vm._s(item)+"鱼币")])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e87b6f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/PreMoney.vue
// module id = null
// module chunks = 